var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-login-wrapper"},[_c('div',{attrs:{"id":"google-btn"}}),_c('div',{staticClass:"custom-overlay-button"},[_c('button',{staticClass:"login-m-btn"},[_c('GoogleLogo'),_c('span',[_vm._v("Google")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }